export default "__VITE_ASSET__60092cdf__"